import React from 'react';
import { FadeIn } from './FadeIn';
import { ButtonCTA } from './ButtonCTA';
import { FileText, Smartphone } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-cream pb-16 sm:pb-24" data-id="element-77">
      <div className="w-full h-[60vh] sm:h-[70vh] relative" data-id="element-78">
        <img src="https://cdn.magicpatterns.com/uploads/ws4EGd98ugvGAnj6cGKqU8/heylloyd-image-1776879825384.png" alt="Personas disfrutando comida saludable" className="w-full h-full object-cover" data-id="element-79" />
        <div className="absolute inset-0 bg-black/40" data-id="element-80"></div>

        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-81">
          <FadeIn delay={0.2} data-id="element-82">
            <span className="inline-block py-1 px-3 rounded-full bg-white/20 backdrop-blur-sm text-white text-sm font-medium tracking-wider mb-6 border border-white/30" data-id="element-83">
              NUEVO MÉTODO
            </span>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-84">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-serif font-bold text-white leading-tight mb-6" data-id="element-85">
              PIERDE PESO SIN PASAR HAMBRE Y SIN RENUNCIAR A LA COMIDA QUE TE
              GUSTA
            </h1>
          </FadeIn>

          <FadeIn delay={0.6} data-id="element-86">
            <p className="text-lg sm:text-xl text-white/90 max-w-3xl mx-auto mb-10 font-medium" data-id="element-87">
              Descubre el método simple de sustituciones inteligentes con 32
              recetas fáciles, guía para comer en restaurantes y estrategia
              social para mantenerte en control incluso los fines de semana.
            </p>
          </FadeIn>

          <FadeIn delay={0.8} data-id="element-88">
            <div className="flex flex-col sm:flex-row items-center gap-4 mb-10" data-id="element-89">
              <div className="flex items-center text-white/90 bg-black/30 backdrop-blur-sm py-2 px-4 rounded-full" data-id="element-90">
                <FileText size={18} className="mr-2 text-warm-beige" data-id="element-91" />
                <span className="text-sm font-medium" data-id="element-92">
                  Producto digital en PDF
                </span>
              </div>
              <div className="flex items-center text-white/90 bg-black/30 backdrop-blur-sm py-2 px-4 rounded-full" data-id="element-93">
                <Smartphone size={18} className="mr-2 text-warm-beige" data-id="element-94" />
                <span className="text-sm font-medium" data-id="element-95">Acceso inmediato</span>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={1.0} data-id="element-96">
            <ButtonCTA className="text-lg sm:text-xl px-10 py-5" data-id="element-97" />
          </FadeIn>
        </div>
      </div>
    </section>;
}